<template>
  <div></div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'AutoLogin',
  methods: {
    ...mapActions({ send: 'login' }),
    ...mapMutations(['setIsCustomerService']),
  },
  created() {
    const token = this.$route.query.token;

    if (!token) {
      this.$router.push({ name: 'login' });
      return;
    }

    this.$store.commit('logout');

    const data = {
      token,
      protected: true,
    };

    this.send({ ...data })
      .then(() => {
        this.setIsCustomerService(true);
        this.$router.push({ name: 'dashboard' });
      })
      .catch(() => {
        this.$router.push({ name: 'login' });
      })
      .finally(() => {
        const { state } = this.$store;
        const user = {
          name: state.user.name,
          email: state.user.email,
          emailHmac: state.tawk,
        };
        this.$Tawk.$updateChatUser(user);
      });
  },
};
</script>
